import axios from '@/store/config';

export default {
  state: {
    locations:[]
  },

  getters: {
    getLocationByRentalObjectCode: (state) => {
      return (rentalObjectCode) => {
        return state.locations.find(loc => loc.rentalObjectCode == rentalObjectCode);
      }
    }
  },

  actions: {
    fetchLocationByRentalObjectCode({ commit }, rentalObjectCode){

      return axios.get(['/rentalobjects/', rentalObjectCode, '/location'].join('')).then(response => {
        commit('setLocation', {
          ...response.data,
          "rentalObjectCode": rentalObjectCode
        });
      });

    }
  },

  mutations: {
    setLocation(state, location){
      state.locations.push(location);
    }
  }
}
